﻿window.meterpollschedule = function () {
    var instance = {

        hideButtons: function (id) {
            var buttons = document.getElementsByClassName('actionbtn bulkop');
            for (var i = 0; i < buttons.length; i++) {
                var item = buttons[i];
                item.classList.add('hide');
            }
        }
    };
    return instance;
}();